import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { navItems } from '../sidebar/sidebar-data';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AppSettings } from 'src/app/config';
import { UserAuthService } from 'src/app/auth/userAuth.service';
import { LoginService } from 'src/app/login.service';
import { environment } from 'src/environments/environment';
import { FallbackImageDirective } from 'src/app/common/directive/fallback-image.directive';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { IUsers } from 'src/app/pages/user/iusers';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
  requiresIPD?: boolean;
}
interface selectedLanguage {
  language: string;
  code: string;
  type?: string;
  icon: string;
}

@Component({
  selector: 'app-header',
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    FallbackImageDirective,
    TranslateModule
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  userdetail: IUsers = {} as IUsers;
  showFiller = false;
  options = this.settings.getOptions();

  reportsMenus: quicklinks[] = [];

  public selectedLanguage: selectedLanguage = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: selectedLanguage[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ];

  @Output() optionsChange = new EventEmitter<AppSettings>();
  isLoading: boolean = false;
  profiledd: profiledd[] = [];

  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private _userAuthservice: UserAuthService,
    private _loginservice: LoginService,
    private _router: Router,
    private loaderService: LoaderService
  ) {
    translate.setDefaultLang('en');
    this._router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          this.loaderService.show();
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          setTimeout(() => {
            this.loaderService.hide();
          })
        }
      });
  }

  isReportMenuActive(link: string): boolean {
    return this._router.isActive(link, false);
  }
  get showToggleButton(): boolean {
    return window.innerWidth < 768;
  }

  get showIPD(): boolean {
    return this._loginservice.isIPDTabShown();
  }

  ngOnInit(): void {
    const isIPD = this._loginservice.isIPDTabShown();
    this.reportsMenus = this.buildReportsMenus(isIPD);

    this._userAuthservice.userData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.userdetail = data;
          if (data.avatar) {
            this.userdetail.avatar = environment.imagePath + data.avatar;
          }
        }
      });
    this._userAuthservice.get()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.userdetail = data.result;
        if (data.result.avatar) {
          this.userdetail.avatar = environment.imagePath + data.result.avatar;
        }
      })
    this.profiledd = [
      {
        id: 1,
        img: '/assets/images/svgs/icon-account.svg',
        title: this.translate.instant('MY_PROFILE'),
        subtitle: this.translate.instant('ENTITY.PERSONAL'),
        link: '/userprofile',
      },
      {
        id: 2,
        img: '/assets/images/svgs/icon-setting.svg',
        title: this.translate.instant('SETTING'),
        subtitle: this.translate.instant('CLINIC/HOSPITALDETAILS'),
        link: '/settings',
      },
      // {
      //   id: 3,
      //   img: '/assets/images/svgs/icon-tasks.svg',
      //   title: 'My Tasks',
      //   subtitle: 'To-do and Daily Tasks',
      //   link: '/',
      // },
    ];
  }

  private buildReportsMenus(isIPDEnabled: boolean) {
    const menus = [
      {
        id: 1,
        title: 'Patient Report(OPD)',
        link: '/reports/opd',
      }
    ];

    if (isIPDEnabled) {
      menus.push({
        id: 2,
        title: 'Patient Report(IPD)',
        link: '/reports/ipd',
      });
    }

    menus.push({
      id: 3,
      title: 'Bill',
      link: '/reports/billing',
    });

    return menus;
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  changeLanguage(lang: selectedLanguage): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  logout() {
    this._loginservice.signOut();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  apps: apps[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-user-male.svg',
      title: 'Patient Report',
      subtitle: 'Patient All Reports',
      link: '/apps/chat',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-user-male.svg',
      title: 'Patient(OPD)',
      subtitle: 'Patient OPD Reports',
      link: '/apps/todo',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-user-male.svg',
      title: 'Patient(IPD)',
      subtitle: 'Patient IPD Reports',
      link: '/apps/invoice',
    },
  ];

}

@Component({
  selector: 'search-dialog',
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  templateUrl: 'search-dialog.component.html'
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}